import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILink from 'UIComponents/link/UILink';
import UIFlex from 'UIComponents/layout/UIFlex';
import { getAppShortlink } from 'ecosystem-marketplace-core/assets/utils/urls';
export default function GenericError() {
  const {
    pathname
  } = useLocation();
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    title: unescapedText('marketplace-assets-ui.error.default.title'),
    children: /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      direction: "column",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        className: "m-bottom-2",
        message: "marketplace-assets-ui.error.default.body"
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "marketplace-assets-ui.error.default.cta_jsx",
        options: {
          onRefresh: () => window.location.reload(),
          loginUrl: getAppShortlink({
            pathname
          })
        },
        elements: {
          Link: UILink
        }
      })]
    })
  });
}